import { EmptySetIcon } from '@mm/icons';
import React from 'react';
import './DeletedMessage.pcss';

type Props = {
  customText?: string;
};

export const DeletedMessage = (props: Props) => {
  const { customText } = props;
  const text = customText ? customText : 'This message was deleted';

  return (
    <div className="incoming--message deleted-message">
      <EmptySetIcon className="deleted-message--empty-icon" />
      {text}
    </div>
  );
};
